module.exports =  {
  BLACK:"#1A1615",
  DARK_GREY:"#2E2826",
  MEDIUM_GREY:"#2E2826",
  LIGHT_GREY:"#979797",
  ULTRA_LIGHT_GREY:"#F0F0F0",
  HIGHLIGHT_COLOR:"#FFE28B",
  HOVER_COLOR:"#FFF8E3",
  UNDERLINE_COLOR:"#4A90E2",
  SUPER_UNDERLINE_COLOR:"#FF8C00",
  ACTIVE_BUTTON_BLUE:"#4A90E2",
  LINK_COLOR: "#2170C4",
  LIGHT_BLUE:"#D2DFF0",
  BLUE: "#B2D0FB",
  GHOST_COLOR:"#C9DFF8",
  ERROR_TEXT: "#D0021B",

  WHITE: "#FFFFFF",

  // Neutral UI scale (Tailwind-derived), used by the Transcripts dashboard.
  // Numbered by lightness, like the legacy *_GREY tokens above but as a full
  // ramp. Near-duplicate one-off greys from the prototype collapse onto these.
  GRAY_50: "#FAFAFA",
  GRAY_100: "#F3F4F6",
  GRAY_200: "#E5E7EB",
  GRAY_300: "#D1D5DB",
  GRAY_400: "#9CA3AF",
  GRAY_500: "#6B7280",
  GRAY_600: "#4B5563",
  GRAY_700: "#374151",
  GRAY_900: "#111827",

  // Dashboard blue accents. The base accent is ACTIVE_BUTTON_BLUE (#4A90E2);
  // these are the deeper text / light background used for a selected filter.
  SELECTED_BLUE_BG: "#EBF3FD",
  SELECTED_BLUE_TEXT: "#2563EB",

  // Destructive-action text (e.g. "Delete Transcript").
  DANGER_RED: "#DC2626"
}
